export default <T>(array: T[], limit: number) => array.sort(() => 0.5 - Math.random()).splice(0, limit)
